import { useIsClusterSecurityAgentInstalled } from 'features/organization/security-insights/hooks/useIsClusterSecurityAgentInstalled';

import { useWasEnabled } from './useWasEnabled';
import { OnboardingPhase2HookProps } from '../types';

export const useWasSecurityEnabled = ({
  clusterId,
  onSuccess,
  onError,
  enabled,
}: OnboardingPhase2HookProps): boolean => {
  const { isInstalled, error } = useIsClusterSecurityAgentInstalled({
    clusterId,
    refetchInterval: 20_000,
    enabled,
  });

  useWasEnabled({
    currentState: isInstalled,
    onSuccess: onSuccess,
    onError: onError,
    error,
    enabled,
  });

  return isInstalled;
};
